module.exports = __webpack_public_path__ + "static/media/b12.7298b523.jpg";